import { useAppSelector } from '../../../hook/useAppSelector';
import { Name } from '../../../interface/response/CashRegisterDataResponse';
import arrow from '../../../assets/img/svg/cash-register/arrow-right.svg';
import MoneyRow from './MoneyRow';
import { useAppDispatch } from '../../../hook/useAppDispatch';
import { setOperatorModalOpen, setSelectedOperator } from '../../../store/slice/operator-details-slice';
import { useFetchDetails } from '../../../hook/useFetchDetails';
import { stringToColor } from '../../../util/stringToColor';
import { CashRegisterMode } from '../../../enum/CashRegisterMode';
import { t } from 'i18next';
interface OperatorsProps {
  mode: string;
}
const Operators: React.FC<OperatorsProps> = ({ mode }) => {
  const dispatch = useAppDispatch();

  const { getOperatorDetails } = useFetchDetails();
  const operatorList = useAppSelector((state) => state.cashRegisterDetails.data.Operators?.OperatorNames);
  const operators = useAppSelector((state) => state.cashRegisterDetails.data.Operators);

  return (
    <div className="operators_container container">
      {mode === CashRegisterMode.CASH_REGISTER_DETAILS && (
        <>
          <div className="item">
            <span className="title">{t('cashRegister.table.details.cashRegisterDetails.operatorVouchers')}</span>
            <div className="values">
              <MoneyRow label={t('cashRegister.table.details.payIn')} amount={operators?.VoucherSum.PayIn} />
              <MoneyRow label={t('cashRegister.table.details.payOut')} amount={operators?.VoucherSum.PayOut} />
              <MoneyRow label={t('cashRegister.table.details.balance')} amount={operators?.VoucherSum.Balance} />
            </div>
          </div>
          <div className="item">
            <span className="title">{t('cashRegister.table.details.cashRegisterDetails.androidVouchers')}</span>
            <div className="values">
              <MoneyRow label={t('cashRegister.table.details.payIn')} amount={operators?.AndroidVoucherSum.PayIn} />
              <MoneyRow label={t('cashRegister.table.details.payOut')} amount={operators?.AndroidVoucherSum.PayOut} />
              <MoneyRow label={t('cashRegister.table.details.balance')} amount={operators?.AndroidVoucherSum.Balance} />
            </div>
          </div>
          <hr />
          {operators?.OperatorNames.length > 0 && (
            <span className="title list">{t('cashRegister.table.details.operatorDetails.listOfOperators')}</span>
          )}
        </>
      )}
      {operatorList?.map((operator: Name, index: number) => (
        <div className={`operator_item item ${index === 0 ? 'first_operator' : ''}`} key={`${operator.UserName}_${index}`}>   

          <div className="operators values">
            <div className="operator_info info">
              <span className="initials" style={{ backgroundColor: stringToColor(operator.UserName) }}>
                {operator.UserName.split(' ')
                  .map((n) => n[0])
                  .join('')}
              </span>
              <span className="operator_name name">{operator.UserName}</span>
            </div>
            <span
              className="operator_details"
              onClick={(e) => {
                 e.stopPropagation();
                dispatch(setSelectedOperator(operator));
                dispatch(setOperatorModalOpen(true));
                getOperatorDetails(operator);
              }}
            >
              <img src={arrow} alt={arrow} />
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Operators;
